jQuery(document).ready(function(){
  
    function go_swatch(product_id){

      var appDomain 	= '//productswatches-herokuapp-com.global.ssl.fastly.net';
      var url 			= appDomain + '/product_swatches/get-json/'+product_id;

      if(product_tag){
        var data = {
            return_format: 'html',
            product_id:product_id, 
            tooltip: 'no',
            tooltip_split: '-',
            tooltip_bg: '555',
            tooltip_color: 'fff',
            tooltip_font_size: '12px',
            tooltip_font: 'sans-serif',
            tooltip_padding: '5px',
            tooltip_border_radius: '6px',
            tooltip_css: '',
            border_radius: '50%',
            border_color: 'ffffff',
            border_active: '1c1c1c',
            border_width: '2',
            width: '35',
            height: '35',
            swatch_title: '',
            hide_sold_out: '',
            tag: product_tag
        };
      }else{
         var data = {
            return_format: 'html',
            product_id:product_id, 
            tooltip: 'no',
            tooltip_split: '-',
            tooltip_bg: '555',
            tooltip_color: 'fff',
            tooltip_font_size: '12px',
            tooltip_font: 'sans-serif',
            tooltip_padding: '5px',
            tooltip_border_radius: '6px',
            tooltip_css: '',
            border_radius: '50%',
            border_color: 'ffffff',
            border_active: '1c1c1c',
            border_width: '2',
            width: '35',
            height: '35',
            swatch_title: '',
            hide_sold_out: ''
        };
      }

   
      $.ajax({
          type: 'post',
          url: url,
          data: data,
          cache: false,
          dataType: "html",
          success: function(data) {
           // console.log(product_idx);
           // console.log(".product-swatches-"+product_id);
            $(".product-swatches-"+product_id).html(data);
          }
      });
      
    }
  
  
  	$(".product-swatches").each(function() {
  	
      product_id 	= $(this).data('id');
      product_idx 	= $(this).data('id');
      product_tag 	= $(this).data('tag');

      //console.log(product_id);
      go_swatch(product_id)
  
  	
  	}); // end .each

}); // end on document ready